import React from 'react';
import { Button } from 'react-bootstrap';

const BootstrapStarterCardCardOptions = ({
    row,
    toggleMenuForRow,
    hideMainMenu,
    isMenuOpenForRow,
    createNewRowAbove,
    createNewRowBelow,
    moveRowUp,
    moveRowDown,
    deleteRow
}) => {
    return (
        <div id="cardOptionsContainer" className="cardOptionsContainer">
            <Button
                onClick={() => {
                    toggleMenuForRow(row.id, 'cardOptions');
                    hideMainMenu();
                }}
                id="buttonCardManager"
                className="responsive-icon-button btn-sm buttonCardManagerhover"
            >
                <div id="iconCardManagerImageBox" className="iconCardManagerImageBox">
                    <img className="buttonCardManagerImg" alt="Card Options" />
                </div>
            </Button>
            {isMenuOpenForRow(row.id, 'cardOptions') && (
                <div id="cardOptions" className="cardMenuColcardColumnorToggle cardOptions">
                    <div
                        id="cardOptionsTitleContainer"
                        className="cardOptionsTitleContainer"
                    >
                        <div
                            id="cardOptionsTitleContainerTextBox"
                            className="cardOptionsTitleContainerTextBox"
                        >
                            <p
                                id="cardOptionsTitle" className="cardOptionsTitle"
                            >
                                Options for Card {row.id}</p>
                        </div>
                        <div
                            id="cardOptionsTitleContainerCloseButtonBox"
                            className="cardOptionsTitleContainerCloseButtonBox"
                        >
                            <Button
                                className="closeCardOptions"
                                onClick={() => toggleMenuForRow(row.id, 'cardOptions')}
                                id="closeOpenCardOptions"
                            >
                                <img
                                    id="closeCardOptionsImg"
                                    className="closeCardOptionsImg"
                                    src="/SVGicons/X-white.svg"
                                    alt="Close"
                                    style={{ width: '12px', height: '12px' }}
                                />
                            </Button>
                        </div>
                    </div>
                    <Button
                        size="sm"
                        id="cardOptionsButtonBoxCreateNewCardAbove"
                        className="responsive-icon-button cardOptionsButton"
                        onClick={() => createNewRowAbove(row.id)}
                    >
                        <div
                            id="cardOptionsButtonBoxCreateNewCardAbove"
                            className="cardOptionsButtonBox"
                        >
                            <div
                                id="cardOptionsButtonBoxImageCreateNewCardAbove"
                                className="cardOptionsButtonBoxImage"
                            >
                                <img
                                    id="iconCreateNewCardAbove"
                                    src="/SVGicons/card-new-above-black.svg"
                                    alt="Create New Card Above"
                                />
                            </div>
                            <div
                                id="cardOptionsButtonBoxTextCreateNewCardAbove"
                                className="cardOptionsButtonBoxText"
                            >
                                <span className="button-text">Create New Card ABOVE</span>
                            </div>
                        </div>
                    </Button>
                    <Button
                        size="sm"
                        id="cardOptionsButtonBoxCreateNewCardBelow"
                        className="responsive-icon-button cardOptionsButton"
                        onClick={() => createNewRowBelow(row.id)}
                    >
                        <div
                            id="cardOptionsButtonBoxCreateNewCardBelow"
                            className="cardOptionsButtonBox"
                        >
                            <div
                                id="cardOptionsButtonBoxImageCreateNewCardBelow"
                                className="cardOptionsButtonBoxImage"
                            >
                                <img
                                    id="iconCreateNewCardBelow"
                                    src="/SVGicons/card-new-below-black.svg"
                                    alt="Create New Card Below"
                                />
                            </div>
                            <div
                                id="cardOptionsButtonBoxTextCreateNewCardBelow"
                                className="cardOptionsButtonBoxText"
                            >
                                <span className="button-text">Create New Card BELOW</span>
                            </div>
                        </div>
                    </Button>
                    <Button
                        size="sm"
                        id="cardOptionsButtonBoxMoveThisCardUp"
                        className="responsive-icon-button cardOptionsButton"
                        onClick={() => moveRowUp(row.id)}
                    >
                        <div
                            id="cardOptionsButtonBoxMoveThisCardUp"
                            className="cardOptionsButtonBox"
                        >
                            <div
                                id="cardOptionsButtonBoxImageMoveThisCardUp"
                                className="cardOptionsButtonBoxImage"
                            >
                                <img
                                    id="iconMoveThisCardUp"
                                    src="/SVGicons/arrowup-black.svg"
                                    alt="Move This Card Up"
                                />
                            </div>
                            <div
                                id="cardOptionsButtonBoxTextMoveThisCardUp"
                                className="cardOptionsButtonBoxText"
                            >
                                <span className="button-text">Move This Card UP</span>
                            </div>
                        </div>
                    </Button>
                    <Button
                        size="sm"
                        id="cardOptionsButtonBoxMoveThisCardDown"
                        className="responsive-icon-button cardOptionsButton"
                        onClick={() => moveRowDown(row.id)}
                    >
                        <div
                            id="cardOptionsButtonBoxMoveThisCardDown"
                            className="cardOptionsButtonBox"
                        >
                            <div
                                id="cardOptionsButtonBoxImageMoveThisCardDown"
                                className="cardOptionsButtonBoxImage"
                            >
                                <img
                                    id="iconMoveThisCardDown"
                                    src="/SVGicons/arrowdown-black.svg"
                                    alt="Move This Card Down"
                                />
                            </div>
                            <div
                                id="cardOptionsButtonBoxTextMoveThisCardDown"
                                className="cardOptionsButtonBoxText"
                            >
                                <span className="button-text">Move This Card DOWN</span>
                            </div>
                        </div>
                    </Button>
                    <Button
                        size="sm"
                        id="cardOptionsButtonBoxDeleteThisCard"
                        className="responsive-icon-button cardOptionsButton"
                        onClick={() => deleteRow(row.id)}
                    >
                        <div
                            id="cardOptionsButtonBoxDeleteThisCard"
                            className="cardOptionsButtonBox"
                        >
                            <div
                                id="cardOptionsButtonBoxImageDeleteThisCard"
                                className="cardOptionsButtonBoxImage"
                            >
                                <img
                                    id="iconDeleteThisCard"
                                    src="/SVGicons/trash-black.svg"
                                    alt="DELETE This Card"
                                />
                            </div>
                            <div
                                id="cardOptionsButtonBoxTextDeleteThisCard"
                                className="cardOptionsButtonBoxText"
                            >
                                <span className="button-text">DELETE This Card</span>
                            </div>
                        </div>
                    </Button>
                </div>
            )}
        </div>
    );
};

export default BootstrapStarterCardCardOptions;